import { gql } from '@apollo/client'
import settings from '@nobia/zeus-components/lib/settings'

import { SearchAddressResponseFragment } from '../../graphql/PostcodeSearchFragment'

const SearchAddressQuery = gql`
  ${SearchAddressResponseFragment}
  query SearchAddressQuery($input: SearchAddressInput!) {
    searchAddress(input: $input) {
      ...SearchAddressResponse
    }
  }
`

export const findAddress = (client, text) => {
  if (!text) {
    return null
  }
  return client
    .query({
      query: SearchAddressQuery,
      variables: {
        input: {
          searchText: text,
          countries: [settings.addressCountry],
          limit: 200,
        },
      },
    })
    .then((result) => result.data.searchAddress.items)
}

export const findSpecificAddress = (client, refinementId) =>
  client
    .query({
      query: SearchAddressQuery,
      variables: {
        input: {
          searchText: '',
          countries: [settings.addressCountry],
          refinementId,
          limit: 200,
        },
      },
    })
    .then((result) => result.data.searchAddress.items)
